<div class="container-fluid">
  <page-header-search
  [isSearchInput]="true"
  [pageTitleValue]="pageTitle"
  [placeholderValue]="placeholder"
  (onHeaderInputKeyup)="onSearchInputKeyup($event)"
  (onHeaderSearchSubmit)="onSearchArea($event)"
></page-header-search>

  <div *ngIf="filteredAreas.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Areas</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredAreas">
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.enName }}</span>
              </td>
              <td>
                <span>{{ item.cityName }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isActive"
                      type="checkbox"
                      id="active-check"
                      (change)="onAreaActiveChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
